export default "__VITE_ASSET__Cg152KNb__"